<template>
  <div class="layout-wrapper">
    <nav-bar class="layout-header" />

    <div class="main-container">
      <transition name="fade-transform" mode="out-in">
        <app-main />
      </transition>
    </div>
  </div>
</template>

<script>
import { NavBar, AppMain } from './components'

export default {
  name: 'NavBarLayout',

  components: {
    NavBar,
    AppMain
  }
}
</script>

<style scoped lang="scss">
.layout-wrapper {
  width: 100%;
  height: 100vh;

  .layout-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1000;
  }

  .main-container {
    padding-top: $header-height;
  }
}
</style>
